import { UseGQLQueryConfig } from 'hooks/useGQLQuery/useGQLQuery.types';
import { QUERY_continueCalloutDialog } from 'queries';
import {
  ContinueCalloutDialogQuery,
  ContinueCalloutDialogQueryVariables,
  Order,
} from 'types/graphql';

export type ContinueCalloutDialogData = { order: Order };

export const continueCalloutDialogConfig = (
  orderRelayId: string,
): UseGQLQueryConfig<
  ContinueCalloutDialogQuery,
  ContinueCalloutDialogData,
  ContinueCalloutDialogQueryVariables
> => {
  return {
    key: 'SHIFT_DISTRIBUTION_FETCH_COMMUNITY_QUERY',
    query: QUERY_continueCalloutDialog,
    variables: {
      orderRelayId,
    },
    responseTransformer: (rawData) => {
      const node = rawData?.node;
      if (!node) return null as unknown as ContinueCalloutDialogData;
      return { order: node as Order };
    },
  };
};
